import styled from "@emotion/styled";
export const SvgContainer = styled.div`
  position: relative;
  display: inline-block;
  height: 600px;
  width: 300px;
  border-radius: 10px;
  box-shadow: 0px 3px 19px -11px rgba(30, 33, 95, 1);
`;
export const Svg = styled.svg`
  display: block;
  height: 100%;
`;
export const SvgPointer = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  background: transparent;
  border: 3px solid red;
  border-radius: 50%;
  pointer-events: none;
`;
